import { setCookie,clearCookies } from '@/utils/common'

const login = {
  state: {
    lastLoginTime: '',                  //上一次登录时间
    listFirstMenu: [],                  //一级菜单
    listsecondMenu: [],                 //二级菜单
    listThreeMenu: [],                  //三级菜单
    userName: '',                       //用户名
    roleName: ''                        //角色
  },
  mutations: {
    SET_USER: (state, user) => {
      state.userName = user;
      setCookie('userName',user)
    },
    SET_ROLE: (state, role) => {
      state.roleName = role;
      setCookie('roleName',role)
    },
    SET_LOGINTIME: (state, loginTime) => {
      state.lastLoginTime = loginTime;
      setCookie('lastLoginTime',loginTime);
    },
    SET_FIRSTMENU: (state, firstMenu) => {
      state.listFirstMenu = firstMenu;
      setCookie('listFirstMenu',firstMenu)
    },
    SET_SECONDMENU: (state, secondMenu) => {
      state.listsecondMenu = secondMenu;
      setCookie('listsecondMenu',secondMenu)
    },
    SET_THREEMENU: (state, threeMenu) =>{
      state.listThreeMenu = threeMenu;
      setCookie('listThreeMenu',threeMenu)
    },
    REMOVE_ALL_COOKIES: (state)=>{
      clearCookies()
    }
  },
}
export default login;



// WEBPACK FOOTER //
// ./src/store/modules/login.js